import { AfterViewChecked, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pallet } from '../stock-levels-modal.component';
import { CrateType, translateState } from 'src/models/Crate';
import { getCrateTypeName } from 'src/app/helpers/format-crate-type';
import { ActionService } from 'src/app/core/services/action.service';
import { ErrorService } from 'src/app/core/services/error.service';
import formatDate from 'src/app/helpers/format-date';
import { CratesDataSourceService } from 'src/app/core/data-sources/crates-data-source.service';
import { ActionsEnum, SendTasksTypeEnum } from 'src/app/core/data-sources/action-data-source.service';
import { UserRoles } from 'src/models/User';
import { TenantInterface } from 'src/models/Tenant';
import { ActionPermissionsService } from 'src/app/core/services/action-permissions.service';
import { TenantService } from 'src/app/core/services/tenant.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-crate-list-details',
  templateUrl: './crate-list-details.component.html',
  styleUrls: ['./crate-list-details.component.scss']
})
export class CrateListDetailsComponent implements OnInit, AfterViewChecked {
  @Input() pallets: Pallet[] = [];
  @Input() palletToScrollTo: string;
  @Output() palletDetailsClicked = new EventEmitter<Pallet>();
  @Output() historyClicked = new EventEmitter<Pallet>();
  @Output() commentsClicked = new EventEmitter<Pallet>();
  @Output() inventoryClicked = new EventEmitter<Pallet>();
  @Output() relocateClicked = new EventEmitter<Pallet>();
  CrateTypeEnum = CrateType;
  isBlocked = false;
  tenant: TenantInterface;
  userRole: UserRoles = null;
  sendTaskTypesEnum = SendTasksTypeEnum;

  constructor(
    private actionService: ActionService,
    private cratesService: CratesDataSourceService,
    private errorService: ErrorService,
    private actionPermissionsService: ActionPermissionsService,
    private tenantService: TenantService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.tenantService.get().then(t => this.tenant = t);
    this.userRole = this.route.snapshot.firstChild?.data.role;
  }

  ngAfterViewChecked(): void {
    const element = document.getElementById(this.palletToScrollTo);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      this.palletToScrollTo = null;
    }
  }

  openPalletDetails(pallet: Pallet) {
    this.palletDetailsClicked.emit(pallet);
  }

  openHistory(pallet: Pallet) {
    this.historyClicked.emit(pallet);
  }

  openComments(pallet: Pallet) {
    this.commentsClicked.emit(pallet);
  }

  inventoryPallet(pallet: Pallet) {
    this.inventoryClicked.emit(pallet);
  }

  relocatePallet(pallet: Pallet) {
    this.relocateClicked.emit(pallet);
  }

  async blockPallet(pallet) {
    try {
      await this.actionService.setPalletUnderAlert({ crateId: pallet.id, deviceName: 'ADM' });
      const updatedPalletAlert = await this.cratesService.getPalletsUnderAlert([pallet.id]);
      pallet.cratesUnderAlert = updatedPalletAlert[0].cratesUnderAlert;
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    }
  }

  async unblockPallet(pallet) {
    try {
      await this.actionService.unsetPalletUnderAlert({ crateId: pallet.id, deviceName: 'ADM' });
      const updatedPalletAlert = await this.cratesService.getPalletsUnderAlert([pallet.id]);
      pallet.cratesUnderAlert = updatedPalletAlert[0].cratesUnderAlert;
    } catch (e) {
      this.errorService.openErrorSnackBar(e);
    }
  }

  formatType(type) {
    return getCrateTypeName(type);
  }

  formatTimestamp(timestamp: number) {
    return formatDate(timestamp);
  }

  translatePalletState(state) {
    return translateState(state);
  }

  canRelocate(action: ActionsEnum | SendTasksTypeEnum, role: UserRoles) {
    if (!this.tenant?.features.relocation) {
      return false;
    }
    return this.actionPermissionsService.hasPermission(action, role);
  }

}
